import { createAnalyticsCategories } from '@analytics/utils';
import { inject, Injectable } from '@angular/core';
import { CustomProduct } from '@product/const';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class ProductDetailAnalyticsService {
  private analyticsService = inject(AnalyticsService);

  onViewPhoto(product: CustomProduct): void {
    const categoryNamesForAnalytics = product.categoryNamesForAnalytics
      ? createAnalyticsCategories(product.categoryNamesForAnalytics)
      : {};

    this.analyticsService.sendEvent({
      event: 'view_photos',
      ...categoryNamesForAnalytics,
    });
  }

  onClickProductTabs(product: CustomProduct, label: string): void {
    const categoryNamesForAnalytics = product.categoryNamesForAnalytics
      ? createAnalyticsCategories(product.categoryNamesForAnalytics)
      : {};

    this.analyticsService.sendEvent({
      event: 'productcard_nav',
      tab_label: label,
      ...categoryNamesForAnalytics,
    });
  }
}
